// extracted by mini-css-extract-plugin
export default {"container":"HowItWorks_container__AbOsw","cards":"HowItWorks_cards__-GMyW","card":"HowItWorks_card__9JIsX","info":"HowItWorks_info__8ENAj"};